import { FC, SyntheticEvent, useEffect, useState } from "react";
import LeaderBoardHeader from "./LeaderBoardHeader";
import TabPanel from "@mui/material/Tabs";
import { Tab, Tabs } from "@mui/material";

import classes from "./LeaderBoard.module.css";
import { ArtworkModelDocument } from "../gallery/Gallery";
import { useSelector } from "react-redux";
import { userState } from "../../store/user";
import axios from "axios";
import GlobalAppLoading from "../UI/GlobalAppLoading";
import { getLang, i18n } from "../../i18n";

interface UserModelDocument {
  _id: string;
  index: number;
  tokens: string[];
  referrerUserID?: string;
  inviteCode: string;
  firstName: string;
  lastName: string;
  userName: string;
  hash: string;
  telegramID: number;
  registeredDate: Date;
  totalProfitARTC: number;
  totalARTC: number;
  freeARTCtakenDate: Date;
  isDeleted: boolean;
  totalCorrectVotesCount: number;
  totalFinishedBattlesVotesCount: number;
  totalVotesCount: number;
  captchaErrors: number;
  isBlockedDate: Date;
  slotsBought: number;
  votesSlotUnlocked: boolean;
  totalFinishedBattlesCount: number;
  battlesSlotUnlocked: boolean;
  totalNFTsCount: number;
  nftsSlotUnlocked: boolean;
  totalInvitedFriendsCount: number;
  totalInvitedActiveUsersCount: number;
  invitesSlotUnlocked: boolean;
  paidSlotUnlocked: boolean;
  totalArtworkValue?: number;
  deckValue?: number;
}

interface Props {
  setPopupImage: React.Dispatch<React.SetStateAction<string>>;
}

const LeaderBoard: FC<Props> = ({ setPopupImage }) => {
  const lang = getLang();
  const t = i18n.leaderboard[lang];

  const API_URL = process.env.REACT_APP_API_URL;
  const user = useSelector(userState);
  const [screenIsLoading, setScreenIsLoading] = useState(true);
  const [value, setValue] = useState("arts");
  const [users, setUsers] = useState<UserModelDocument[] | []>([]);
  const [voters, setVoters] = useState<UserModelDocument[] | []>([]);
  const [artworks, setArtworks] = useState<ArtworkModelDocument[] | []>([]);
  const [place, setPlace] = useState(0);
  const handleTabChange = (
    e: SyntheticEvent<Element, Event>,
    tabIndex: any
  ) => {
    window.scrollTo({
      top: 31,
      behavior: "smooth",
    });
    setValue(tabIndex);
  };
  useEffect(() => {
    console.log("leaderboard use effect");
    const getUserLeaderboard = async () => {
      setScreenIsLoading(true);
      await axios
        .get(`${API_URL}/users/leaderboard`, {
          withCredentials: true,
          headers: { Authorization: `Bearer ${user.sessionToken}` },
        })
        .then((response) => {
          setPlace(response.data.place);
          setUsers(response.data.users);
          setVoters(response.data.voters);
          setArtworks(response.data.artworks);
          setScreenIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setScreenIsLoading(false);
        });
    };

    getUserLeaderboard();
  }, []);
  if (screenIsLoading) return <GlobalAppLoading text={t.loadingLeaderboard} />;

  return (
    <>
      <LeaderBoardHeader place={place} />
      <section className={classes.leaderboard}>
        <Tabs
          variant="fullWidth"
          value={value}
          onChange={handleTabChange}
          className={classes.tabs}
        >
          <Tab value="arts" label={t.artworks} />
          <Tab value="users" label={t.authors} />
          <Tab value="voters" label={t.voters} />
        </Tabs>

        {value === "arts" && (
          <TabPanel value="arts" className={classes.tabPanel}>
            <div className={`${classes.list} ${classes.arts}`}>
              {artworks.map((art, index) => (
                <div
                  className={`${classes.art} ${
                    art.userID === user._id ? classes.self : ""
                  }`}
                >
                  <div className={classes.place}>{index + 1}</div>
                  <div
                    className={classes.img}
                    onClick={() => setPopupImage(art._id)}
                  >
                    <span className={classes.popupIcon}>
                      {/* SVG omitted for brevity */}
                    </span>
                    <img
                      src={art.imageAmazonS3ThumbURL || art.imageAmazonS3URL}
                      alt=""
                    />
                  </div>
                  <div className={classes.info}>
                    <div className={classes.artTop}>
                      <div className={classes.level}>
                        {/* Level stars SVG */}
                      </div>
                      <div className={classes.profit}>
                        {Math.round(art.value)} 💎
                      </div>
                    </div>
                    <div
                      className={`${classes.title} ${
                        (art.silentVotesCount > 0 ||
                          art.battleVotesCount > 0) &&
                        (art.silentVotesWinner + art.battleVotesWinner) /
                          (art.silentVotesCount + art.battleVotesCount) >=
                          0.7
                          ? classes.gold
                          : (art.silentVotesCount > 0 ||
                              art.battleVotesCount > 0) &&
                            (art.silentVotesWinner + art.battleVotesWinner) /
                              (art.silentVotesCount + art.battleVotesCount) >=
                              0.5
                          ? classes.silver
                          : classes.bronze
                      }`}
                    >
                      {art.title}
                    </div>
                    {(art.silentVotesCount > 0 || art.battleVotesCount > 0) && (
                      <div className={classes.winrate}>
                        {t.winrate}&nbsp;
                        <span>
                          {(
                            ((art.silentVotesWinner + art.battleVotesWinner) /
                              (art.silentVotesCount + art.battleVotesCount)) *
                            100
                          ).toFixed(0)}
                          %
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </TabPanel>
        )}

        {value === "users" && (
          <TabPanel value="users" className={classes.tabPanel}>
            <div className={`${classes.list} ${classes.users}`}>
              {users.map((leaderboardUser, index) => (
                <div
                  className={`${classes.user} ${
                    leaderboardUser._id === user._id ? classes.self : ""
                  }`}
                >
                  <div className={classes.userLeft}>
                    <div className={classes.place}>{index + 1}</div>
                    <div className={classes.nickname}>
                      {leaderboardUser.userName ||
                        `${leaderboardUser.firstName} ${leaderboardUser.lastName}`}
                    </div>
                  </div>
                  <div className={classes.profit}>
                    {Math.round(leaderboardUser.totalArtworkValue || 0)} 💎
                  </div>
                </div>
              ))}
            </div>
          </TabPanel>
        )}

        {value === "voters" && (
          <TabPanel value="voters" className={classes.tabPanel}>
            <div className={`${classes.list} ${classes.users}`}>
              {voters.map((leaderboardUser, index) => (
                <div
                  className={`${classes.user} ${
                    leaderboardUser._id === user._id ? classes.self : ""
                  }`}
                >
                  <div className={classes.userLeft}>
                    <div className={classes.place}>{index + 1}</div>
                    <div className={classes.nickname}>
                      <span
                        className={
                          leaderboardUser.totalFinishedBattlesVotesCount > 0 &&
                          leaderboardUser.totalCorrectVotesCount /
                            leaderboardUser.totalFinishedBattlesVotesCount >=
                            0.75
                            ? classes.gold
                            : leaderboardUser.totalFinishedBattlesVotesCount >
                                0 &&
                              leaderboardUser.totalCorrectVotesCount /
                                leaderboardUser.totalFinishedBattlesVotesCount >=
                                0.5
                            ? classes.silver
                            : classes.bronze
                        }
                      >
                        {leaderboardUser.userName ||
                          `${leaderboardUser.firstName} ${leaderboardUser.lastName}`}
                      </span>{" "}
                      {leaderboardUser.totalFinishedBattlesVotesCount >= 10 && (
                        <span className={classes.expertRate}>
                          {(
                            (leaderboardUser.totalCorrectVotesCount /
                              leaderboardUser.totalFinishedBattlesVotesCount) *
                            100
                          ).toFixed(0)}
                          %
                        </span>
                      )}
                    </div>
                  </div>
                  <div className={classes.profit}>
                    {leaderboardUser.deckValue?.toFixed(0)} 💎
                  </div>
                </div>
              ))}
            </div>
          </TabPanel>
        )}
      </section>
    </>
  );
};

export default LeaderBoard;
